// src/app/services/geocoding.service.ts
import { Injectable } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';

export interface LocationInfo {
  city: string;
  country: string;
}

@Injectable({ providedIn: 'root' })
export class GeocodingService {
  private geocoder!: google.maps.Geocoder;

  constructor() {
    const loader = new Loader({
      apiKey: 'AIzaSyCsHEkJ4qR39yLHK2XqmcjL3_gbnxJqwSM'
    });
    loader.load().then(() => {
      this.geocoder = new google.maps.Geocoder();
    });
  }

  /**
   * Dados lat/lng, resuelve ciudad y país
   */
  reverseGeocode(lat: number, lng: number): Promise<LocationInfo> {
    return new Promise((resolve, reject) => {
      if (!this.geocoder) {
        return reject('Geocoder no inicializado');
      }

      this.geocoder.geocode(
        { location: { lat, lng } },
        (results, status) => {
          if (status !== 'OK' || !results || results.length === 0) {
            return reject(`Geocoding falló: ${status}`);
          }

          const components = results[0].address_components;

          // Extraer ciudad: prioridad locality, luego administrative_area_level_1
          const cityComp = components.find(c =>
            c.types.includes('locality')
          ) || components.find(c =>
            c.types.includes('administrative_area_level_1')
          );

          // Extraer país
          const countryComp = components.find(c =>
            c.types.includes('country')
          );

          const city    = cityComp?.long_name  || '';
          const country = countryComp?.long_name || '';

          resolve({ city, country });
        }
      );
    });
  }
}
